<div class="flex-column h-100">
  <app-portal-header class="app-header" [displayRightMenu]="false" [displayRightLogo]="true" [displayCalendarIcon]="false"></app-portal-header>
  <div class="flex-row w-100 h-100 justify-content-center">
    <div class="alert alert-error page-alert">
      Resource not found.You can proceed to
      <a routerLink="/">home</a> page
    </div>
  </div>
  <app-main-footer></app-main-footer>
</div>
